<div class="relative flex h-screen flex-col" id="main-content">
    <div class="sticky top-0 z-10 flex h-[50px] w-full items-center bg-white" *ngIf="isChannelMobile">
        <ion-button
            class="pn-light:text-primary pn-app-light:text-primary dark:text-contrast-yellow"
            [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
            (click)="goBack()"
            fill="clear"
            size="large">
            <ion-icon
                class="mr-1 text-xl dark:filter-yellow"
                title="{{ 'LOCAL_BTN_BACK' | translate }}"
                aria-label="{{ 'LOCAL_BTN_BACK' | translate }}"
                aria-hidden="true"
                src="{{ assetsPath$ | async }}/img/cards/icon-left-arrow.svg"></ion-icon>
        </ion-button>
    </div>

    <article
        class="block flex-grow overflow-y-auto px-5 pb-5"
        [ngClass]="{ 'pt-5': !isChannelMobile }"
        [innerHTML]="'FAQ_TEXT' | translate"></article>
</div>
